module.exports = __webpack_public_path__ + "static/media/pediatricPatient_meals_intro.fc91951e.png";